export enum EModals {
  Intro = "intro",
  PartnerPicker = "partnerPicker",
  Form = "form",
  Outro = "outro",
  EnergyTransfer = "energyTransfer",
}
